import _styled from '@emotion/styled/base';
import { border, elevation } from '@hubble/tokens/web';
import * as SelectPrimitive from '@radix-ui/react-select';
import { createFormElementWrapper, LeftElementWrapper as LeftElementWrapper$1, RightElementWrapper as RightElementWrapper$1, createFloatingLabel } from '../shared/composableStyles.js';
import { Spacing } from '../../primitives/spacing.js';

const SelectWrapper = createFormElementWrapper();
const LeftElementWrapper = LeftElementWrapper$1;
const RightElementWrapper = RightElementWrapper$1;
const FloatingLabel = createFloatingLabel();
const Trigger = _styled(SelectPrimitive.Trigger, {
  target: "ew77ayz5"
})("all:unset;display:flex;align-items:center;width:100%;height:100%;background-color:transparent;cursor:pointer;&[data-placeholder]{color:", ({
  theme
}) => theme.colorScheme.input.content.placeholder, ";}&:disabled{cursor:not-allowed;}");
const TriggerContent = _styled("div", {
  target: "ew77ayz4"
})({
  name: "gbsj7k",
  styles: "flex:1;min-width:0;display:flex;align-items:center"
} );
const Content = _styled(SelectPrimitive.Content, {
  shouldForwardProp: prop => prop !== 'wrapperWidth',
  target: "ew77ayz3"
})("overflow:hidden;background-color:", ({
  theme
}) => theme.colorScheme.background.primary, ";border-radius:", border.radius.md, ";border:1px solid ", ({
  theme
}) => theme.colorScheme.input.border.enabled, ";box-shadow:", elevation.selectMenu, ";z-index:10000;width:", ({
  wrapperWidth
}) => wrapperWidth ? `${wrapperWidth}px` : 'var(--radix-select-trigger-width)', ";max-height:var(--radix-select-content-available-height);");
const Viewport = _styled(SelectPrimitive.Viewport, {
  target: "ew77ayz2"
})("padding:", Spacing.scale[1], ";display:flex;flex-direction:column;gap:", Spacing.scale[0.5], ";");
const Item = _styled(SelectPrimitive.Item, {
  target: "ew77ayz1"
})("all:unset;display:flex;align-items:center;padding:", Spacing.scale[1], ";border-radius:", border.radius.sm, ";user-select:none;cursor:pointer;color:", ({
  theme
}) => theme.colorScheme.content.primary, ";&:hover,&[data-highlighted]{background-color:", ({
  theme
}) => theme.colorScheme.background.secondary, ";}&[data-disabled]{color:", ({
  theme
}) => theme.colorScheme.content.disabled, ";cursor:not-allowed;}");
const ItemText = _styled(SelectPrimitive.ItemText, {
  target: "ew77ayz0"
})({
  name: "82a6rk",
  styles: "flex:1"
} );

export { Content, FloatingLabel, Item, ItemText, LeftElementWrapper, RightElementWrapper, SelectWrapper, Trigger, TriggerContent, Viewport };
